import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=5840b960&scoped=true"
import script from "./ProfileEdit.js?vue&type=script&lang=js&external"
export * from "./ProfileEdit.js?vue&type=script&lang=js&external"
import style0 from "./ProfileEdit.scss?vue&type=style&index=0&id=5840b960&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5840b960",
  null
  
)

export default component.exports